@if (enabled) {
  <button
    class="transparent-btn"
    [disabled]="submitted"
    (click)="openModal()"
    ngbTooltip="Envoyer le contrat signé"
    i18n-ngbTooltip
  >
    <app-arrow-right-icon height="16px" width="16px" color="var(--brand-500)" />
  </button>
  <app-action-modal
    #actionModal
    [disabled]="submitted"
    [submitDisabled]="submitDisabled"
    [showHeader]="true"
    submitButtonClass="lty-btn-primary"
    size="lg"
    headerIconState="success"
    customModalClass="send-signed-proposal-modal"
    (submitted)="sendSignedContract()"
    (closed)="onClosed()"
  >
    <div class="proposals-send-icon d-flex" headerIcon>
      <app-send-icon height="16px" width="16px" color="var(--success-500)" />
    </div>
    <ng-container mainTitle i18n
      >Envoyer la proposition N°
      {{ signedProposal?.policyDetails?.offerId }}</ng-container
    >
    <ng-container subtitle>
      <form class="lty-form mt-12" [formGroup]="form">
        <div class="form-group mb-16">
          <label for="contract-channel" i18n>Envoi</label>
          <div class="position-relative">
            <select
              class="form-control"
              id="contract-channel"
              formControlName="channel"
            >
              <option [value]="Channel.IN_APP" i18n>Par mail</option>
              <option [value]="Channel.INSURER_PLATFORM" i18n>
                À travers la plateforme de l'assureur (manuel)
              </option>
              <option [value]="Channel.POSTAL" i18n>Par courrier</option>
            </select>
            <i class="bi bi-chevron-down edge-element"></i>
          </div>
        </div>

        @if (isInAppSend) {
          <div class="form-group mb-16">
            <label for="contract-recipient" i18n>Destinataire</label>
            <input
              class="form-control"
              type="text"
              id="contract-recipient"
              [value]="recipientEmail"
              [placeholder]="renderLoading ? loadingText : ''"
              readonly
            />
          </div>

          <div class="form-group mb-16">
            <label i18n>Mandat de gestion</label>
            <app-signed-contract-document-combobox
              [control]="form.controls.managementAgreement"
              [familyMemberId]="familyMemberId"
              [userId]="userId"
              [contractType]="ContractType.MANAGEMENT_AGREEMENT"
              [required]="false"
            />
          </div>

          <div class="form-group mb-16">
            <label i18n>Carte d'identité</label>
            <app-document-summary-combobox
              [control]="form.controls.identityCard"
              [userId]="userId"
              [memberId]="familyMemberId"
              [type]="DocumentType.IDENTITY_CARD"
              noneLabel="Aucune"
              i18n-noneLabel
            />
          </div>
          <div class="form-group mb-16">
            <label i18n>Certificat de signature</label>
            <app-document-summary-combobox
              [control]="form.controls.signatureCertificate"
              [userId]="userId"
              [memberId]="familyMemberId"
              [type]="DocumentType.SIGNATURE_CERTIFICATE"
            />
          </div>

          <!-- `modalOpen` is a TinyMCE lifecycle gate; see `ComposeModalBase`. It also
               keeps the picker from searching before the modal is up. -->
          @if (modalOpen) {
            <app-document-picker
              [control]="form.controls.attachments"
              [userId]="userId ?? ''"
              [familyMemberId]="familyMemberId ?? ''"
              label="Autre(s) document(s)"
              i18n-label
              [allowUpload]="true"
            />

            <div class="form-group mb-16">
              <label i18n>Corps du mail</label>
              <editor
                formControlName="body"
                [plugins]="editorPlugins"
                [toolbar]="editorToolbar"
              />
            </div>
          }
        }
      </form>
    </ng-container>
    <ng-container submitButtonLabel i18n>Confirmer</ng-container>
  </app-action-modal>
}
